import styled from "@emotion/styled";
import { Alert } from "@kaltura/ds-react-components";
import { generalHtmlStyles } from "@kaltura/mediaspace-shared-ui";
import { translate, translatePlural } from "@kaltura/mediaspace-shared-utils";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

const StyledAlert = styled(Alert)(({ theme }) => [
    generalHtmlStyles(theme),
    {
        "& .board-message-text": { color: theme.kaltura.palette.tone1 },
    },
]);

export interface NotificationProps {
    /**
     * is showing the notification for channel or gallery
     */
    isChannel: boolean;

    /**
     * number of media pending moderation
     */
    pending: number;

    /**
     * category moderation page URL
     */
    url: string;
}

/**
 * "items pending approve" notification component
 */
export const Notification = ({ isChannel, pending, url }: NotificationProps) => {
    const msg = translatePlural("%1 item pending approval.", "%1 items pending approval.", [pending]);

    const sendButtonAnalytics = useButtonAnalytics();

    const handleNavigate = () => {
        sendButtonAnalytics(`${isChannel ? "Channel" : "Gallery"} moderation alert`, ButtonClickAnalyticsType.NAVIGATE);
    };

    return (
        <StyledAlert classes={{ message: "channel-notification" }} severity={"warning"}>
            <span>
                {msg}
                &nbsp;
                <a href={url} onClick={handleNavigate}>
                    {translate("View list")}
                </a>
            </span>
        </StyledAlert>
    );
};

export default Notification;
